// const lGrammar = ["Grammar", "Gramática"];
// const arrow = ["Arrow", "Seta"];
// const variableEnum = ["VARIABLEₙᵤₘ", "VARIÁVELₙᵤₘ"];
// const descToggleArrow = "->";
// const descToggleVarEnum = ["VARIABLE_not number", "VARIÁVEL_não sendo número"];
// const descToggleLambda = ["point", "ponto"];
// const descToggleGrammar = ["Click me", "Clique aqui"];
// const lSubmit = ["GO!", "IR!"];

// module.exports = {
//   lGrammar,
//   arrow,
//   variableEnum,
//   descToggleArrow,
//   descToggleVarEnum,
//   descToggleLambda,
//   descToggleGrammar,
//   lSubmit,
// };
export default {
  menu: {
    lGrammar: {
      en: "Grammar",
      pt: "Gramática",
    },
    arrow: {
      en: "Arrow",
      pt: "Seta",
    },
    variableEnum: {
      en: "VARIABLEₙᵤₘ",
      pt: "VARIÁVELₙᵤₘ",
    },
    descToggleArrow: {
      en: "->",
      pt: "->",
    },
    descToggleVarEnum: {
      en: "VARIABLE_not number",
      pt: "VARIÁVEL_não sendo número",
    },
    descToggleLambda: {
      en: "point",
      pt: "ponto",
    },
    descToggleGrammar: {
      en: "Click me",
      pt: "Clique aqui",
    },
    lSubmit: {
      en: "GO!",
      pt: "IR!",
    },
  },
  modal: {
    arrow: {
      en: "How to write the production symbol.",
      pt: "Como escrever o símbolo de produção.",
    },
    lambda: {
      en: "How to write the lambda symbol.",
      pt: "Como escrever o símbolo lambda.",
    },
    grammar: {
      en: "How to write a grammar",
      pt: "Como escrever uma gramática.",
    },
    varenum: {
      en: "How to write the numeric variable.",
      pt: "Como escrever uma variável numérica.",
    },
  },
  alert: {
    save: {
      en: "Grammar created",
      pt: "Gramática criada",
    },
    update: {
      en: "Grammar updated",
      pt: "Gramática atualizada",
    },
    autoSave: {
      en: "Grammar was saved automatically",
      pt: "Gramática salva automaticamente",
    },
    autoUpdate: {
      en: "Grammar was updated automatically",
      pt: "Gramática atualizada automaticamente",
    },
    rulesLimitMessage: {
      en: "Maximum number of productions reached: ",
      pt: "Número máximo de regras atingido: ",
    },
  },
};
